import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'


const _hoisted_1 = { class: "menuPageBox" }
const _hoisted_2 = { class: "menuPageBoxTop" }
const _hoisted_3 = { class: "headLeft" }
const _hoisted_4 = { class: "headLeftImg" }
const _hoisted_5 = { class: "headLeftTxt" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "headRight" }

import { computed,nextTick, onMounted,reactive,ref, watch,} from "vue";
// 引入我的模块
import mainBox from "@/components/common/mainBox.vue";
import { useRouter,useRoute } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'menuPage',
  props: {
    nameInfo: Object,
},
  emits: ['closemenu','openmenu'],
  setup(__props, { emit: __emit }) {

const route=useRoute()
const router = useRouter();
const props = __props
const mainBoxRef = ref();
onMounted(() => {
  document.addEventListener("click", (event) => {
    // console.log(event);
    closeAll();
  });
});
const closeAll = () => {
    // if(mainBoxRef.value!=undefined || mainBoxRef.value!=null||mainBoxRef.value.closes()!=null||mainBoxRef.value.closes()!=undefined){
    //     mainBoxRef.value.closes();
    // }
  mainBoxRef.value?.closes();
};
const emit = __emit
const closemenuFun=()=>{
    emit('closemenu')
}
const openmenuFun=()=>{
    emit('openmenu')
}
// 跳转新页面
const gotoNewPage=(type:string)=>{
    console.log('跳转新页面')
    localStorage.setItem('pageType',type)
    nextTick(()=>{
        router.push("/");
    })
}
const toHome=()=>{
    router.push("/");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "logoImg",
            onClick: _withModifiers(toHome, ["stop"])
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(props.nameInfo.name) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(props.nameInfo.version), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(mainBox, {
          class: "topMain",
          ref_key: "mainBoxRef",
          ref: mainBoxRef,
          onCloseAll: closeAll
        }, null, 512)
      ])
    ]),
    _createElementVNode("div", {
      class: "menuPageBoxBtm",
      onMouseout: closemenuFun,
      onMouseover: openmenuFun
    }, [
      _createElementVNode("div", {
        class: "tabBoxInner",
        onMouseover: openmenuFun
      }, [
        _createElementVNode("div", {
          class: "listBoxInnerOne",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (gotoNewPage('caption')), ["stop"])),
          style: {"margin-right":"4.7rem"}
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "routOneTitle" }, "灵犀", -1),
          _createElementVNode("span", { class: "routOneTitleInfo" }, "(字幕、分类、翻译制作)", -1)
        ])),
        _createElementVNode("div", {
          class: "listBoxInnerOne",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (gotoNewPage('aiVoice')), ["stop"])),
          style: {"margin-right":"5.6rem"}
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "routOneTitle" }, "幻音", -1),
          _createElementVNode("span", { class: "routOneTitleInfo" }, "(AI换声)", -1)
        ])),
        _createElementVNode("div", {
          class: "listBoxInnerOne",
          style: {"margin-right":"2.8rem"},
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (gotoNewPage('filmAi')), ["stop"]))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("span", { class: "routOneTitle" }, "阅影", -1),
          _createElementVNode("span", { class: "routOneTitleInfo" }, "(观影系统)", -1)
        ])),
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"listBoxInnerOne\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>万物智文</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(语言大模型集成平台)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:4.8rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>元启</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(AI 数字人)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:5.5rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>优视</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(视频超分)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:2.8rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>优译</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(AI翻译)</span></div><div class=\"listBoxInnerOne\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>大白鲸</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(企业&amp;项目全流程管理系统)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:4.7rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>优洽</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(123Uchat 聊天)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:5.6rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>创画</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(文生图片)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:2.8rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>幻颜</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(AI换脸)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:4.7rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>123蜜蜂+</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(数字加密系统)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:4.8rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>元溯</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(数字管理系统)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:5.6rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>智言</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(文生语音)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:2.8rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>优画</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(图片超分)</span></div><div class=\"listBoxInnerOne\" style=\"margin-right:4.7rem;\" data-v-ef7aca6e><span class=\"routOneTitleNo\" data-v-ef7aca6e>识声</span><span class=\"routOneTitleInfo\" data-v-ef7aca6e>(语种翻译，音色克隆，口型同步)</span></div>", 13))
      ], 32)
    ], 32)
  ]))
}
}

})